import React, { useEffect, useRef, useState } from "react";
import {
  GeneralContainer,
  FormContainer,
  FormField,
  SelectionField,
  FormPreviewContainer,
  PreviewPanel,
  ChooseFormContainer,
  ContentModalSaveSurveyAnswer,
  CloseModalSurveyAnswer,
  TextModalSurveyAnswer,
  ButtonSurveyAnswer,
  useStyles,
  customStyles,
} from "./MyInsightsContainer.styled";
import Paper from "@material-ui/core/Paper";
import Select from "react-select";
import {
  CASES_BY_USER_PROFILE_AFTER,
  CASES_BY_USER_PROFILE_BEFORE,
  CASES_BY_USER_PROFILE_FIRST,
  CASE_STATUSES,
  FORMS_BY_USER_PROFILE,
  GET_FORM_QUESTIONS,
} from "../../GraphQL/Queries";
import { CREATE_CASE } from "../../GraphQL/Mutations";
import { useLazyQuery, useMutation } from "@apollo/client";
import { clientPolicyIngsight } from "../../App";
import { ReactComponent as ChooseFormIcon } from "../../assets/svg/no-form-selected.svg";
import MyInsightListComponent from "../../components/MyInsightListComponent/MyInsightListComponent";
import { useHistory, useLocation } from "react-router-dom";
import FormFilling from "../../components/FormsManagement/FormFilling/FormFilling";
import PortalModal from "../../Portals/PortalModal";
import ThumbDownAltOutlinedIcon from "@material-ui/icons/ThumbDownAltOutlined";
import { NotificationManager } from "react-notifications";
import ModalConfirm from "../../components/ModalConfirm";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { AntTab, AntTabs } from "../../helpers/antTabs";

const MyInsightsContainer = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [myInsightsList, setMyInsightsList] = useState([]);
  const [searchTxt, setSearchTxt] = useState("");
  const rSearch = useRef();
  const rStatus = useRef();
  const [page, setPage] = useState(0);
  const [allPages, setAllPages] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rowsPerPageOptions] = useState([5, 10, 20]);
  const [startCursor, setStartCursor] = useState("");
  const [endCursor, setEndCursor] = useState("");
  const [statusValue, setStatusValue] = useState(null);
  const [dateValue, setDateValue] = useState(null);
  const [activeHightPriority, setActiveHightPriority] = useState(false);
  const [showCards, setShowCards] = useState(false);
  const [value, setValue] = useState(0);
  const [selectedMenu, selectMenu] = useState(["form", "Form Selection"]);
  const [forms, setForms] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [formSelected, setFormSelected] = useState();
  const [questionsData, setQuestionsData] = useState([]);
  const [mandatoryMissing, setmandatoryMissing] = useState([]);
  const [QuestionsSave, setQuestionsSave] = useState([]);
  const [openErrorModal, setopenErrorModal] = useState(false);
  const [caseId, setCaseId] = useState();
  const rForm = useRef();
  const [myListStatuses, setMyListStatuses] = useState([]);
  const rDateValue = useRef();
  const [renderAgain, setRenderAgain] = useState();
  const [highPriority, setHighPriority] = useState(false);
  const [highPriorityReasons, setHighPriorityReason] = useState("");
  const [showError, setShowError] = useState(false);

  const [saveFormAnswers] = useMutation(CREATE_CASE, {
    client: clientPolicyIngsight,
  });

  const [runQueryCasesByUserProfileFirst, { loading: loadingFirstInsights }] =
    useLazyQuery(CASES_BY_USER_PROFILE_FIRST, {
      fetchPolicy: "network-only",
      client: clientPolicyIngsight,
      onCompleted: (data) => {
        if (data?.casesByUserProfile) {
          asignData(data);
          setShowLoader(false);
        }
      },
    });

  const [runQueryCasesByUserProfileAfter, { loading: loadingAfterInsights }] =
    useLazyQuery(CASES_BY_USER_PROFILE_AFTER, {
      fetchPolicy: "network-only",
      client: clientPolicyIngsight,
      onCompleted: (data) => {
        if (data?.casesByUserProfile) {
          asignData(data);
          setShowLoader(false);
        }
      },
    });

  const [runQueryCasesByUserProfileBefore, { loading: loadingBeforeInsights }] =
    useLazyQuery(CASES_BY_USER_PROFILE_BEFORE, {
      fetchPolicy: "network-only",
      client: clientPolicyIngsight,
      onCompleted: (data) => {
        if (data?.casesByUserProfile) {
          asignData(data);
          setShowLoader(false);
        }
      },
    });

  const [runQueryListOfStatuses] = useLazyQuery(CASE_STATUSES, {
    fetchPolicy: "network-only",
    client: clientPolicyIngsight,
    onCompleted: (data) => {
      if (data?.caseStatuses) {
        let list = data.caseStatuses.map((item, index) => {
          return {
            value: item.idCaseStatus,
            label: item.statusName,
          };
        });
        setMyListStatuses([...list]);
      }
    },
  });

  const [runQueryForms] = useLazyQuery(FORMS_BY_USER_PROFILE, {
    fetchPolicy: "network-only",
    client: clientPolicyIngsight,
    onCompleted: (data) => {
      if (Array.isArray(data.formsByUserProfile)) {
        let formsList = data.formsByUserProfile.map((item) => {
          let value = item.idForm;
          let label = item.name;
          /*             buttonText: `${JSON.parse(JSON.parse(item.jsonConfiguration).TextButtonSave.jsonConfiguration).text}`,
            title: `${JSON.parse(JSON.parse(item.jsonConfiguration).Title.jsonConfiguration).text}`, */
          return {
            value: value,
            label: label,
          };
        });
        setForms([...formsList]);
      }
      setShowLoader(false);
    },
  });

  const [runQueryFormQuestions] = useLazyQuery(GET_FORM_QUESTIONS, {
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-and-network",
    client: clientPolicyIngsight,
    onCompleted: (data) => {
      if (data?.formQuestionsByIdForm) {
        let questions = data.formQuestionsByIdForm;
        questions = questions.map((e) => {
          return {
            ...e,
            tpsurveyAnswerQuestionSurveys: [
              {
                internalCode: null,
              },
            ],
          };
        });
        setQuestionsData([...questions]);
        setShowLoader(false);
      }
    },
  });

  useEffect(() => {
    setShowLoader(true);
    runQueryForms();
    runQueryListOfStatuses();
    runQueryCasesByUserProfileFirst({
      variables: {
        searchBy: searchTxt,
        caseStatusId: statusValue,
        date: dateValue,
        hightPriority: activeHightPriority ? activeHightPriority : null,
        first: rowsPerPage,
      },
    });
  }, [
    activeHightPriority,
    dateValue,
    renderAgain,
    rowsPerPage,
    searchTxt,
    statusValue,
  ]);

  useEffect(() => {
    if (
      searchTxt ||
      statusValue ||
      dateValue ||
      activeHightPriority ||
      activeHightPriority === false
    ) {
      setPage(0);
      runQueryCasesByUserProfileFirst({
        variables: {
          searchBy: searchTxt,
          caseStatusId: statusValue,
          date: dateValue,
          hightPriority: activeHightPriority ? activeHightPriority : null,
          first: rowsPerPage,
        },
      });
    }
  }, [searchTxt, statusValue, dateValue, activeHightPriority, rowsPerPage]);

  useEffect(() => {
    if (location?.state?.tab) {
      handleChange(null, location?.state?.tab);
    }
  }, [location]);

  const handleChange = (event, newValue) => {
    if (newValue === 0) selectMenu(["form", "Form Selection"]);
    if (newValue === 1) selectMenu(["insights", "My Insights"]);
    setValue(newValue);
    setFormSelected();
    setRenderAgain(!renderAgain);
  };

  const handleSeeDetails = (rowData) => {
    history.push({ pathname: "/MyInsightDetail", state: { detail: rowData } });
  };

  const getDataBySearch = () => {
    setSearchTxt(rSearch?.current?.value);
  };

  const applySearchOnBreak = () => {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(() => {
        getDataBySearch();
      }, 500);
    };
  };

  const handleSearch = applySearchOnBreak();

  const asignData = (data) => {
    setAllPages(data.casesByUserProfile.totalCount);
    if (data.casesByUserProfile.pageInfo.hasNextPage === true) {
      setEndCursor(data.casesByUserProfile.pageInfo.endCursor);
    }
    if (data.casesByUserProfile.pageInfo.hasPreviousPage === true) {
      setStartCursor(data.casesByUserProfile.pageInfo.startCursor);
    }
    const casesByUserProfile = data.casesByUserProfile.nodes.map((cup) => ({
      ...cup,
    }));
    if (casesByUserProfile) {
      setMyInsightsList(casesByUserProfile);
    } else {
      setMyInsightsList([]);
    }
  };

  const handleChangePage = (item, newPage) => {
    if (newPage > page) {
      setShowLoader(true);
      runQueryCasesByUserProfileAfter({
        variables: {
          searchBy: searchTxt,
          caseStatusId: statusValue,
          date: dateValue,
          hightPriority: activeHightPriority ? activeHightPriority : null,
          first: rowsPerPage,
          after: endCursor,
        },
      });
    }
    if (newPage < page) {
      setShowLoader(true);
      runQueryCasesByUserProfileBefore({
        variables: {
          searchBy: searchTxt,
          caseStatusId: statusValue,
          date: dateValue,
          hightPriority: activeHightPriority ? activeHightPriority : null,
          first: rowsPerPage,
          before: startCursor,
        },
      });
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (item) => {
    setRowsPerPage(item.target.value ? parseInt(item.target.value) : 5);
    setPage(0);
    runQueryCasesByUserProfileFirst({
      variables: {
        searchBy: searchTxt,
        caseStatusId: statusValue,
        date: dateValue,
        hightPriority: activeHightPriority ? activeHightPriority : null,
        first: item.target.value ? parseInt(item.target.value) : 5,
      },
    });
  };

  const handleChangeStatus = (event) => {
    setStatusValue(event?.value);
  };

  const handleChangeDate = (event) => {
    if (event.currentTarget.value !== "") {
      setDateValue(new Date(event.currentTarget.value).toJSON());
    }
  };

  const handleChangeForm = (e) => {
    let formId = e?.value;
    if (formId) {
      setQuestionsData([]);
      setShowLoader(true);
      setFormSelected(e);
      runQueryFormQuestions({ variables: { idForm: formId } });
    }
  };

  const resetFilters = () => {
    rStatus.current?.clearValue();
    rDateValue.current.value = "";
    setStatusValue(null);
    setDateValue(null);
    setSearchTxt("");
  };

  const saveForm = (formData) => {
    let mandatory = [];

    questionsData.forEach((x) => {
      if (x.isMandatory) {
        let exists = QuestionsSave.filter((q) => {
          return q.idQuestion === x.idQuestionForm;
        });
        if (exists.length === 0) {
          mandatory.push(x.idQuestionForm);
        } else if (exists.length > 0) {
          let questionSavedData = exists[0];
          if (!questionSavedData.answerClient.toString()) {
            mandatory.push(x.idQuestionForm);
          }
        }
      }
    });
    if (highPriority && highPriorityReasons.trim() === "") {
      setShowError(true);
      return;
    } else {
      setShowError(false);
    }
    if (mandatory.length > 0) {
      setmandatoryMissing(mandatory);
      setopenErrorModal(true);
      return;
    }
    setShowLoader(true);
    let answerClients = QuestionsSave.map((Q) => {
      if (Q.typeQuestion === "File") {
        return {
          idQuestionForm: Q.idQuestion,
          answer: Q.answerClient.toString(),
          idCase: 0,
          base64FileContent: Q.base64FileContent,
        };
      } else {
        return {
          idQuestionForm: Q.idQuestion,
          answer: Q.answerClient.toString(),
          idCase: 0,
        };
      }
    });
    let idFormData = formData?.value ? formData.value : formData;
    saveFormAnswers({
      variables: {
        idForm: idFormData,
        caseAnswersParameter: answerClients,
        highPriorityReasons: highPriority ? highPriorityReasons : "",
        highPriority: highPriority,
      },
    })
      .then((res) => {
        if (res?.data?.createCase?.idCase) {
          setCaseId(res.data.createCase.idCase);
          setShowLoader(false);
        } else {
          setShowLoader(false);
          NotificationManager.error("Something went wrong in creating case");
        }
      })
      .catch((error) => {
        setShowLoader(false);
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const showSelectedMenu = () => {
    switch (selectedMenu[0]) {
      case "form":
        return (
          <FormContainer>
            <FormField>
              <label>Select a form</label>
              <SelectionField>
                <Select
                  styles={customStyles}
                  placeholder="Select an option"
                  ref={rForm}
                  options={forms}
                  onChange={(e) => handleChangeForm(e)}
                />
              </SelectionField>
            </FormField>
            <FormPreviewContainer>
              <PreviewPanel
                className={formSelected ? "form-selected" : "choose-form"}
              >
                {!formSelected && (
                  <ChooseFormContainer>
                    <ChooseFormIcon />
                    <label>To continue, please select a form from the</label>
                    <label style={{ fontWeight: 700 }}>dropdown above.</label>
                  </ChooseFormContainer>
                )}
                {formSelected && (
                  <>
                    <FormFilling
                      formData={formSelected}
                      questiondata={questionsData}
                      saveForm={saveForm}
                      mandatoryMissing={mandatoryMissing}
                      QuestionsSave={QuestionsSave}
                      setQuestionsSave={setQuestionsSave}
                      setHighPriority={setHighPriority}
                      setHighPriorityReason={setHighPriorityReason}
                      showError={showError}
                    />
                  </>
                )}
              </PreviewPanel>
            </FormPreviewContainer>
          </FormContainer>
        );
      case "insights":
        return (
          <MyInsightListComponent
            ref={{ rSearch, rStatus, rDateValue }}
            statusValue={statusValue}
            handleChangeStatus={handleChangeStatus}
            dateValue={dateValue}
            handleChangeDate={handleChangeDate}
            activeHightPriority={activeHightPriority}
            setActiveHightPriority={setActiveHightPriority}
            handleSearch={handleSearch}
            showCards={showCards}
            setShowCards={setShowCards}
            myInsightsList={myInsightsList}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            rowsPerPageOptions={rowsPerPageOptions}
            rowsPerPage={rowsPerPage}
            page={page}
            allPages={allPages}
            handleSeeDetails={handleSeeDetails}
            myListStatuses={myListStatuses}
            resetFilters={resetFilters}
            loadingFirstInsights={loadingFirstInsights}
            loadingAfterInsights={loadingAfterInsights}
            loadingBeforeInsights={loadingBeforeInsights}
          />
        );
      default:
        return "";
    }
  };

  const showSaveErrorModal = () => {
    return openErrorModal ? (
      <PortalModal>
        <ContentModalSaveSurveyAnswer>
          <CloseModalSurveyAnswer>
            <span onClick={() => setopenErrorModal(false)}>X</span>
          </CloseModalSurveyAnswer>
          <TextModalSurveyAnswer>
            <ThumbDownAltOutlinedIcon />
            <p>Your answers are not complete</p>
          </TextModalSurveyAnswer>
          <ButtonSurveyAnswer onClick={() => setopenErrorModal(false)}>
            Close
          </ButtonSurveyAnswer>
        </ContentModalSaveSurveyAnswer>
      </PortalModal>
    ) : null;
  };

  const handleRedirect = () => {
    setQuestionsData([]);
    setFormSelected();
    rForm.current.clearValue();
  };

  return (
    <GeneralContainer>
      <Paper square style={{ marginBottom: "17px" }}>
        <AntTabs className={classes.tabs} value={value} onChange={handleChange}>
          <AntTab label="Form Selection" />
          <AntTab label="My Insights" />
        </AntTabs>
      </Paper>
      {showSelectedMenu()}
      {showSaveErrorModal()}
      {caseId && (
        <ModalConfirm
          info={`Your case was successfully created with the ID: `}
          infoVar={caseId}
          handleConfirm={handleRedirect}
          setModalVisibility={setCaseId}
          showCancel={false}
          modalTitle="Information"
        />
      )}
      {showLoader && <ModalLoader />}
    </GeneralContainer>
  );
};

export default MyInsightsContainer;
